<div class="fd-checkbox__container">
  <mat-checkbox [name]="field?.controlName" class="fd-checkbox" [formGroup]="parentForm"
    [formControl]="relatedFormControl">{{field?.label}}</mat-checkbox>
</div>
<mat-error *ngIf="hasError">
  <div *ngFor="let errorMessage of errorMessages">{{errorMessage}}</div>
</mat-error>
